// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "roberta-ferec.firebaseapp.com",
  "projectId": "roberta-ferec",
  "storageBucket": "roberta-ferec.firebasestorage.app",
  "messagingSenderId": "1030877682435",
  "appId": "1:1030877682435:web:605bfe728b21133ffc2736",
  "measurementId": "G-PYKMVSMGLL",
  "apiKey": "AIzaSyAfeZ0QAvi8Xi2l51HIHRhXpn7qYQ1X71U"
};
